import * as React from 'react';
export var PortalContext = /*#__PURE__*/React.createContext({
  className: ''
});
//# sourceMappingURL=portalContext.js.map
